import * as React from "react";
import { format } from "lib/globalize-util";
import LoginForm from "./login-form";
import Dialog from "material-ui/Dialog";
import Button from "components/form/button";
import AlertDialog from "components/dialog/alert";
import { getLsidConfig } from "lib/lsid";
import LoginFormSSO from "./login-form-sso";
import { FlowTypes } from "lib/lsid/enums";

interface ILoginDialogProps {
    redirect?: string;
    open: boolean;
    onToggleDialog: any;
    onRequestForgotPassword: ({ email, recaptchaClientKey }) => void;
    onResetState: () => void;
    authentication: any;
    onTrackLoginArticles: () => void;
    onTrackLoginRegistration: () => void;
    onTrackLoginVideo: () => void;
    onRedirectToForgotPassword: () => void;
}

interface IState {
    showForgotAlert: boolean;
    loginFlow: FlowTypes;
    email?: string;
}

export class LoginDialog extends React.PureComponent<ILoginDialogProps, IState> {
    dialogStyles = {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
    };

    state = { showForgotAlert: false, loginFlow: FlowTypes.LEGACY, email: "" };

    handleClose = () => {
        this.setState({ showForgotAlert: false });
        this.props.onToggleDialog(false);
    };

    handleSwitchLoginFlow = (flow: FlowTypes) => {
        this.setState({ loginFlow: flow });
    };

    setSharedEmail = (email: string) => {
        this.setState({ email });
    };

    render() {
        const {
            open,
            redirect,
            authentication,
            onResetState,
            onTrackLoginArticles,
            onTrackLoginRegistration,
            onTrackLoginVideo,
            onRedirectToForgotPassword,
        } = this.props;
        const { forgotPasswordSuccess, postingForgotPassword } = authentication;
        const { showForgotAlert = false, loginFlow } = this.state || {};
        const { hasSSO } = getLsidConfig();

        const actions = [<Button key="cancel" label={format("Cancel")} primary={true} onClick={this.handleClose} />];

        return (
            <React.Fragment>
                {showForgotAlert && !postingForgotPassword && forgotPasswordSuccess ? (
                    <AlertDialog title={format("Email Sent!")} onRequestClose={this.handleClose} open={open}>
                        {format("Please check your email for additional instructions.")}
                    </AlertDialog>
                ) : (
                    <Dialog
                        contentStyle={this.dialogStyles as any}
                        actions={actions}
                        modal={true}
                        open={open}
                        style={{ zIndex: 10000 }}
                    >
                        {!(hasSSO && loginFlow === FlowTypes.SSO) ? (
                            <LoginForm
                                redirect={redirect}
                                onRequestForgotPassword={this.props.onRequestForgotPassword}
                                authentication={authentication}
                                onResetState={onResetState}
                                onTrackLoginRegistration={onTrackLoginRegistration}
                                onTrackLoginArticles={onTrackLoginArticles}
                                onTrackLoginVideo={onTrackLoginVideo}
                                onRedirectToForgotPassword={onRedirectToForgotPassword}
                                onSwitchLoginFlow={this.handleSwitchLoginFlow}
                                setSharedEmail={this.setSharedEmail}
                                sharedEmail={this.state.email}
                            />
                        ) : (
                            <LoginFormSSO
                                authentication={authentication}
                                redirect={redirect}
                                onResetState={onResetState}
                                onSwitchLoginFlow={this.handleSwitchLoginFlow}
                                setSharedEmail={this.setSharedEmail}
                                sharedEmail={this.state.email}
                                isMobile={false}
                            />
                        )}
                    </Dialog>
                )}
            </React.Fragment>
        );
    }
}

export default LoginDialog;
